<template>
	<Component
		:is="componentType"
		v-bind="linkProps"
		class="flex items-center w-full gap-2 px-4 py-2 text-base font-normal text-left transition-colors duration-150 text-neutral-700 hover:bg-neutral-100 hover:text-neutral-900 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-grey-500"
		:class="active ? 'bg-grey-200 rounded-lg' : 'bg-transparent'"
		data-action-menu-item
		@click="handleClick"
	>
		<slot name="icon">
			<Icon
				v-if="icon"
				:icon="[iconPrefix, icon]"
				:size="iconSize"
				class="shrink-0"
			/>
		</slot>
		<span
			class="flex-1"
			:class="truncate ? 'min-w-0 truncate' : 'whitespace-nowrap'"
		>
			<slot />
		</span>
	</Component>
</template>

<script>
import Icon from '~/components/ui/common/Icon'

export default {
	name: 'ActionMenuItem',
	components: {
		Icon
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		icon: {
			type: String,
			default: null
		},
		iconPrefix: {
			type: String,
			default: 'far'
		},
		iconSize: {
			type: String,
			default: 'sm'
		},
		to: {
			type: [String, Object],
			default: null
		},
		href: {
			type: String,
			default: null
		},
		target: {
			type: String,
			default: null
		},
		truncate: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		componentType() {
			if (this.to) {
				return 'NuxtLink'
			}

			if (this.href) {
				return 'a'
			}

			return 'button'
		},
		linkProps() {
			if (this.to) {
				return {
					to: this.to
				}
			}

			if (this.href) {
				return {
					href: this.href,
					target: this.target
				}
			}

			return {
				type: 'button'
			}
		}
	},
	methods: {
		handleClick(event) {
			this.$emit('click', event)
		}
	}
}
</script>
